import { AfterViewInit, Component, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { SgAriaMessage } from '../../models/sg-aria-message';
import { ToastMessageService } from 'cbc-shared-lib';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as lodash from 'lodash';

/**
 * メッセージ表示共通コンポーネント
 * @export
 * @class SgAriaMessageComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
  selector: 'app-sg-aria-message',
  templateUrl: './sg-aria-message.component.html',
  styleUrls: ['./sg-aria-message.component.scss']
})
export class SgAriaMessageComponent implements OnInit, OnDestroy, AfterViewInit {

  // メッセージモデル
  @Input() @Output() errorMessageModelArray: Array<SgAriaMessage>;

  // 表示したいエラーのタイプ(エラーか、警告か)
  @Output() readonly errorType: any = {
    error: "error",
    warning: "warning"
  };

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @memberof SgAriaMessageComponent
   */
  constructor(
    private toastMessageService: ToastMessageService,
    private zone: NgZone
  ) { }

  /**
   * 初期処理
   * @memberof SgAriaMessageComponent
   */
  ngOnInit(): void {
    this.errorMessageModelArray = [];

    // システムエラーをエラーメッセージエリアに表示する
    this.toastMessageService.errValueChages
      .pipe(
        takeUntil(this.onDestroy$)
      )
      .subscribe((response) => {
        if (!this.errorMessageModelArray) {
          this.errorMessageModelArray = new Array<SgAriaMessage>();
        }
        if (lodash.isEmpty(response)) {
          this.errorMessageModelArray = new Array<SgAriaMessage>();
          return;
        }
        let errorMessage: SgAriaMessage = {};
        errorMessage.message = response;
        errorMessage.messageClass = "mat-card-background-error";
        errorMessage.icon = "cancel";
        errorMessage.iconClass = "mat-icon-color-error";
        if (!this.errorMessageModelArray) {
          this.errorMessageModelArray = new Array<SgAriaMessage>();
        }
        this.errorMessageModelArray.push(errorMessage);
      })
  }

  /**
   * 描画直後に実行
   */
  ngAfterViewInit(): void {
    // Angularの描画が安定した後に、システムエラーを初期化する
    this.zone.onStable.pipe(take(1)).subscribe(() => {
      this.toastMessageService.clear();
    });
  }

  ngOnDestroy(): void {
    this.errorMessageModelArray = null;
    this.toastMessageService.clear();
  }
}
